import Vue from 'vue'
import 'default-passive-events'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control

import VueResource from 'vue-resource'

import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import i18n from './lang'
import { initI18n } from '@/utils/i18n'; // 导入初始化函数

Vue.use(VueVirtualScroller)

import { RecycleScroller } from 'vue-virtual-scroller'
Vue.component('RecycleScroller', RecycleScroller)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
 // const { mockXHR } = require('../mock')
 // mockXHR()
}

Vue.use(VueResource)

// set ElementUI lang to EN
// 2024-8-21注释掉这里，改用i18n
// Vue.use(ElementUI, { locale })

// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Vue.use(ElementUI, {
    i18n:(key, value) => i18n.t(key, value)
})

Vue.config.productionTip = false

Vue.prototype._ = require('lodash')
window._ = require('lodash')

const app = new Vue({
 el: '#app',
 router,
 store,
 i18n,
 render: h => h(App),
})


// 初始化 i18n Helper - 传入根实例或 i18n 实例都可以
initI18n(app); // 传入根 Vue 实例